import { observable, action, makeObservable } from 'mobx';

export type ToastType = 'error' | 'warning' | 'success' | 'info';

export interface Toast {
  id: number;
  type: ToastType;
  title: string;
  message?: string;
  duration: number; // ms, 0 = sticky
}

let _nextId = 1;

class ToastService {
  @observable public toasts: Toast[] = [];

  constructor() {
    makeObservable(this);
  }

  @action
  public show(type: ToastType, title: string, message?: string, duration = 5000): number {
    const id = _nextId++;
    this.toasts.push({ id, type, title, message, duration });
    if (duration > 0) {
      setTimeout(() => this.dismiss(id), duration);
    }
    return id;
  }

  public error(title: string, message?: string, duration = 6000) {
    return this.show('error', title, message, duration);
  }

  public warning(title: string, message?: string, duration = 5000) {
    return this.show('warning', title, message, duration);
  }

  public success(title: string, message?: string, duration = 3500) {
    return this.show('success', title, message, duration);
  }

  public info(title: string, message?: string, duration = 4000) {
    return this.show('info', title, message, duration);
  }

  @action
  public dismiss(id: number) {
    this.toasts = this.toasts.filter(t => t.id !== id);
  }
}

export const toastService = new ToastService();
